import React, { useEffect, useCallback, useState, useRef } from 'react';
import classnames from 'classnames';
import { getCommentableTypeForDeviationType } from '../../redux/helpers';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import s from './CommentBoxPanel.scss';
const CommentBoxPanel = ({ deviation , focusEditor , onClose , onThreadUpdated , panelOpenEvent , panelCloseEvent  })=>{
    const rootRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const editorId = `commentpanel-${deviation.deviationId}`;
    const onPanelOpen = useCallback(()=>{
        focusEditor(editorId);
    }, [
        editorId,
        focusEditor
    ]);
    useEffect(()=>{
        panelOpenEvent.addListener(onPanelOpen, true);
        /*
      A transitionend handler is put on the PanelPopup parent that uses scrollTo to follow along
      with any animations that it or it's children have, I guess? Uncertain of the original purpose.

      But we don't want that for our animation here, so stop propagation.
    */ rootRef.current && rootRef.current.addEventListener('transitionend', (e)=>e.stopPropagation());
        return ()=>{
            panelOpenEvent.removeListener(onPanelOpen);
        };
    }, [
        onPanelOpen,
        panelOpenEvent,
        rootRef
    ]);
    const onPublishSuccess = useCallback((result)=>{
        // we wait for the panel animation's finish before the scroll,
        // otherwise it's a really janky effect
        panelCloseEvent.addListener(()=>{
            onThreadUpdated(deviation, result);
        }, true);
        onClose();
    }, [
        panelCloseEvent,
        onThreadUpdated,
        deviation,
        onClose
    ]);
    const handleEditorReady = useCallback(()=>{
        setIsOpen(true);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isOpen && s['open']),
        ref: rootRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['wrapper']
    }, /*#__PURE__*/ React.createElement(CommentBox, {
        id: editorId,
        commentableType: getCommentableTypeForDeviationType(deviation.typeId),
        commentableItemId: deviation.deviationId,
        onPublishSuccess: onPublishSuccess,
        onEditorReady: handleEditorReady,
        onClose: onClose,
        className: s['comment-box'],
        footerClassName: s['comment-box-footer']
    })));
};
CommentBoxPanel.displayName = 'CommentBoxPanel';
export default CommentBoxPanel;
